module.exports = __webpack_public_path__ + "img/microphone-off-01.bc64fed5.svg";